module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/moduleHeader/img/fat-blaster__714f044f7b8e931516b1dd83a61901a0.svg";